import React, { useEffect, useState } from "react";
import ClientDistributonSection from "./VizAppDashboardSections/ClientDistributionSection";
import MetricsSection from "./VizAppDashboardSections/MetricsSection";
import PlanDetailsSection from "./VizAppDashboardSections/PlanDetailsSection";
import TopFivePackageSection from "./VizAppDashboardSections/TopFivePackageSection";
import WelcomeScreenAndPlanSection from "./VizAppDashboardSections/WelcomeScreenAndPlanSection";
import YearWiseMetrics from "./VizAppDashboardSections/YearWiseMetrics";
import SmartReportAddonsTable from "./VizAppDashboardSections/SmartReportAddonsTable";
import SmartReportRepeatRate from "./VizAppDashboardSections/SmartReportRepeatRate";
import ReportTypeSplitChartClient from "./VizAppDashboardSections/ReportTypeSplitChart";
import YearComparisonChart from "./DashboardSections/YearComparisonChart";
import ClientMonthlyCountsChart from "./DashboardSections/ClientMonthlyCountsChart";
import ReportTypeSplitChart from "./DashboardSections/ReportTypeSplitChart";
import TableComponent from "./TableComponent";

import MaintenancePage from "./maintenance";
import LoginOAuth from "./VizAppDashboardSections/loginPageOAuth";
import OnboardingStatus from "./onboardingStatus/OnboardingStatus";
import AdminClientSubscriptionWidget from "./AdminClientSubscriptionWidget";
import { Box, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";

const VizAppDashboard = () => {
  const [clientPreferenceRecord, setClientPreferenceRecord] = useState(false);
  const [reRenderComponent, setReRenderComponent] = useState(false);
  const [roleInfo, setRoleInfo] = useState("");
  const [trialClientData, setTrialClientData] = useState("");
  const [productType, SetProductType] = useState("smartreport");
  const [yearMonthData, setYearMonthData] = useState(null);
  const [reportTypeStats, setReportTypeStats] = useState({ total: null, startDate: '', endDate: '' });
  const [orgPreference, setOrgPreference] = useState("");

  const loginData = JSON.parse(localStorage.getItem("loginDetails"));

  window.addEventListener("storage", (e) => {
    // console.log("something got changed.")
    setReRenderComponent(!reRenderComponent);
  });

  useEffect(() => {
    let clientPreferenceInfo = JSON.parse(
      localStorage.getItem("clientPreference")
    );
    let orgPreferenceInfo = JSON.parse(
      localStorage.getItem("orgPreference")
    );
    let loginInfo = JSON.parse(localStorage.getItem("loginDetails"));
    let trialClientInfo = JSON.parse(
      localStorage.getItem("trialClientPreference")
    );

    if (clientPreferenceInfo) {
      setClientPreferenceRecord(clientPreferenceInfo);
    }
    if (orgPreferenceInfo) {
      setOrgPreference(orgPreferenceInfo);
    }

    if (loginInfo) {
      console.log("role:", loginInfo.role);
      setRoleInfo(loginInfo.role);
    }

    if (trialClientInfo) {
      setTrialClientData(trialClientInfo);
    }
  }, [reRenderComponent]);

  console.log("here:", localStorage.getItem("logoUrl"));

  // Callback to receive data from YearWiseMetrics
  const handleYearMonthDataFetched = (data) => {
    console.log("📊 VizAppDashboard: Received year/month data from YearWiseMetrics", data);
    setYearMonthData(data);
  };

  return (
    <>
      {trialClientData === "yes" ? (
        <>
          <TableComponent />
        </>
      ) : (
        <>
          <OnboardingStatus />

          {/* ── Selected Client Banner — shown at top of page when admin has a client selected ── */}
          {roleInfo === "admin" && clientPreferenceRecord && clientPreferenceRecord !== "none" && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                background: "linear-gradient(135deg, #EEF3FF 0%, #E4EEFF 100%)",
                border: "1px solid #D1DEF9",
                borderRadius: "14px",
                px: "18px",
                py: "12px",
                mb: 3,
              }}
            >
              {/* Icon */}
              <Box sx={{ width: 36, height: 36, borderRadius: "10px", background: "#3567D6", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M3 21h18M3 7l9-4 9 4M4 7v14M20 7v14M8 10v4M12 10v4M16 10v4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Box>

              {/* Labels */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: "10.5px", fontWeight: 700, color: "#3567D6", textTransform: "uppercase", letterSpacing: "0.06em", lineHeight: 1.2 }}>
                  Viewing data for selected client
                </Typography>
                <Stack direction="row" alignItems="center" gap={0.75} mt={0.4} flexWrap="wrap">
                  {orgPreference && (
                    <Typography sx={{ fontSize: "14px", fontWeight: 800, color: "#170C6B", lineHeight: 1.2 }}>
                      {orgPreference}
                    </Typography>
                  )}
                  {orgPreference && clientPreferenceRecord && (
                    <Box sx={{ width: 4, height: 4, borderRadius: "50%", background: "#94A3B8", flexShrink: 0 }} />
                  )}
                  <Box
                    sx={{
                      background: "#3567D6",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 700,
                      borderRadius: "6px",
                      px: "10px",
                      py: "3px",
                      letterSpacing: "0.02em",
                    }}
                  >
                    {clientPreferenceRecord}
                  </Box>
                </Stack>
              </Box>

              {/* Active indicator */}
              <Stack direction="row" alignItems="center" gap={0.6} sx={{ background: "#F0FDF4", border: "1px solid #BBF7D0", borderRadius: "99px", px: "10px", py: "5px", flexShrink: 0 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E" }} />
                <Typography sx={{ fontSize: "10.5px", fontWeight: 700, color: "#16A34A", textTransform: "uppercase", letterSpacing: "0.05em" }}>Active</Typography>
              </Stack>
            </Box>
          )}

          <InputLabel
            sx={{
              color: "#170C6B",
              paddingBottom: "16px",
              fontSize: "22px",
              fontWeight: "500",
            }}
          >
            Select Product
          </InputLabel>
          <Select
            sx={{ color: "#3567d6" }}
            onChange={(e) => SetProductType(e.target.value)}
            value={productType}
          >
            <MenuItem sx={{ color: "#3567d6" }} value={"vizapp"}>
              Viz App
            </MenuItem>
            <MenuItem sx={{ color: "#3567d6" }} value={"smartreport"}>
              Smart Report
            </MenuItem>
            <MenuItem sx={{ color: "#3567d6" }} value={"videoreport"}>
              Video Report
            </MenuItem>
          </Select>

          {/* <LoginOAuth /> */}
          <div className="mb-3">
            {loginData && loginData.role === "lab" && (
              <WelcomeScreenAndPlanSection productType={productType} />
            )}
            {loginData && loginData.role === "admin" && (
              <AdminClientSubscriptionWidget productType={productType} />
            )}
          </div>

          {/* Report Type Split Chart - Only show in admin view */}
          {(!clientPreferenceRecord || clientPreferenceRecord === "none") && roleInfo !== "lab" ? (
            <ReportTypeSplitChart />
          ) : (
            ""
          )}

          <TopFivePackageSection productType={productType} />

          {/* ── Admin Client-Selected Section ───────────────────────────────
              These three cards appear only when admin has a specific client
              selected (clientPreference !== "none"). They show data scoped
              to the selected client via org/center/clientId API params.
          ────────────────────────────────────────────────────────────────── */}
          {roleInfo === "admin" && clientPreferenceRecord && clientPreferenceRecord !== "none" && (
            <>
              {/* 0. Report Type Distribution (client-scoped) */}
              <Box
                sx={{
                  background: "#fff",
                  borderRadius: "16px",
                  boxShadow: "0 2px 16px rgba(53,103,214,0.08)",
                  overflow: "hidden",
                  mb: 3,
                }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ p: "18px 20px 4px" }}>
                  {/* Left: title + subtitle */}
                  <Box>
                    <Typography sx={{ fontWeight: 800, fontSize: "15px", color: "#170C6B", mb: 0.3 }}>
                      Report Type Distribution
                    </Typography>
                    <Typography sx={{ fontSize: "11.5px", color: "#9DA3AE", mb: 1 }}>
                      Breakdown of report types generated this period
                    </Typography>
                  </Box>

                  {/* Right: Total Reports chip */}
                  {reportTypeStats.total !== null && (
                    <Stack direction="row" alignItems="center" gap={0.8} sx={{
                      background: "#FFF7ED",
                      border: "1px solid #fde8c8",
                      borderRadius: "10px",
                      px: 1.25,
                      py: 0.55,
                      flexShrink: 0,
                      ml: 1,
                    }}>
                      <Box sx={{ width: 22, height: 22, borderRadius: "5px", background: "#F8DEBD", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="#BA8139" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: "8.5px", fontWeight: 700, color: "#92700a", textTransform: "uppercase", letterSpacing: "0.05em", lineHeight: 1.2 }}>
                          Total Reports
                        </Typography>
                        <Typography sx={{ fontSize: "13px", fontWeight: 800, color: "#1e293b", lineHeight: 1.2 }}>
                          {reportTypeStats.total.toLocaleString("en-IN")}
                        </Typography>
                        {reportTypeStats.startDate && reportTypeStats.endDate && (() => {
                          const fmt = (d) => {
                            const [y, m, day] = d.split('-');
                            const mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(m,10)-1];
                            return `${day} ${mon}`;
                          };
                          const yr = `'${reportTypeStats.endDate.slice(2,4)}`;
                          return (
                            <Typography sx={{ fontSize: "8px", color: "#b45309", lineHeight: 1.2, mt: 0.1 }}>
                              {fmt(reportTypeStats.startDate)} – {fmt(reportTypeStats.endDate)} {yr}
                            </Typography>
                          );
                        })()}
                      </Box>
                    </Stack>
                  )}
                </Stack>
                <ReportTypeSplitChartClient onStatsChange={(stats) => setReportTypeStats(stats)} />
              </Box>

              {/* 1. Smart Report Add-ons Table */}
              <div className="mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="topFivePackageButtonsCss" style={{ paddingBottom: '4px' }}>
                      <div style={{ fontWeight: 700, fontSize: '15px', color: '#170C6B' }}>Smart Report Add-ons</div>
                    </div>
                    <SmartReportAddonsTable />
                  </div>
                </div>
              </div>

              {/* 2. Patient Repeat Rate Trend */}
              <div className="mb-4">
                <div className="card">
                  <div className="card-body" style={{ paddingBottom: '8px' }}>
                    <div className="topFivePackageButtonsCss" style={{ paddingBottom: '4px' }}>
                      <div style={{ fontWeight: 700, fontSize: '15px', color: '#170C6B' }}>Patient Repeat Rate</div>
                    </div>
                    <SmartReportRepeatRate loginData={loginData} />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* All-clients admin view: distribution chart (no specific client selected) */}
          {clientPreferenceRecord === "none" && roleInfo !== "lab" ? (
            <ClientDistributonSection productType={productType} />
          ) : (
            ""
          )}

          {/* Only show Month wise All Clients chart when no specific client is selected */}
          {!localStorage.getItem("clientIdPreference") && (
            <ClientMonthlyCountsChart />
          )}

          <MetricsSection productType={productType} />

          {/* YearWiseMetrics fetches the data and shares it via callback */}
          <YearWiseMetrics
            productType={productType}
            onDataFetched={handleYearMonthDataFetched}
          />

          {/* YearComparisonChart receives the shared data as prop */}
          <YearComparisonChart yearMonthData={yearMonthData} />

        </>
      )}
      {/* <MaintenancePage /> */}
    </>
  );
};

export default VizAppDashboard;
